import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ModalBaseComponent } from 'app/shared/components/base/modal-base/modal-base.component';
import { Constants } from 'app/shared/constants/constants';
import { PaymentRequest } from 'app/shared/models/payment-request.model';
import { PaymentRequestService } from 'app/shared/services/payment-request.service';
import { PaymentRequestUrlComponent } from '../payment-request-url/payment-request-url.component';

@Component({
  selector: 'app-payment-request',
  templateUrl: './payment-request.component.html',
  styleUrls: ['./payment-request.component.scss']
})

export class PaymentRequestComponent extends ModalBaseComponent implements OnInit {

  descriptionLength: number = 0;
  amount: number = 0;
  smallAmount: number = 0;

  constructor(public paymentRequestService: PaymentRequestService, protected activeModal: NgbActiveModal, protected modalService: NgbModal, protected translateService: TranslateService) {
    super(activeModal);
  }

  ngOnInit() {
    this.initializeObject();
  }

  initializeObject() {
    if (this.currentObject == null) {
      this.currentObject = new PaymentRequest();
    }
    super.initializeObject();

    this.translateService.get(['paymentRequest.addedSuccessfullyMessage'])
      .subscribe(translations => {
        this.addedSuccessfullyMessage = translations['paymentRequest.addedSuccessfullyMessage'];
      });
  }

  descriptionChanged() {
    this.descriptionLength = this.currentObject.RemittanceInformation?.length || 0;
  }

  hasValidAmount() {
    this.currentObject.Amount = this.amount + (this.smallAmount / 100);
    var regex = /^([1-9]\d{0,4})(?!.*[#$^_.,/?;:+=!*()@%&])$/g
    return (this.currentObject.Amount != null) &&
      (this.currentObject.Amount > Constants.AmountMinimumValue) &&
      (this.currentObject.Amount <= Constants.AmountMaximumValue) &&
      regex.test(String(this.amount));
  }

  onSubmit(form: NgForm) {
    super.onSubmit(form);
    this.currentObject.Amount = this.amount + (this.smallAmount / 100);
    if (!form.value.PaymentRequestId) {
      this.paymentRequestService.postPaymentRequest(this.currentObject, (newPaymentRequest: PaymentRequest) => {
          this.handleSubmit(form);
          this.viewPaymentRequestUrl(newPaymentRequest);
        },
        this.addedSuccessfullyMessage);
    }
  }

  viewPaymentRequestUrl(paymentRequest: PaymentRequest) {
    const modalReference = this.modalService.open(PaymentRequestUrlComponent, {
      windowClass: 'add-edit-modal',
      backdropClass: 'modal-backdrop-blur'
    });
    modalReference.componentInstance.currentObject = Object.assign({}, paymentRequest);
  }
}
